module.exports = __webpack_public_path__ + "img/jike-propa.800cb1e8.png";